import { format } from 'date-fns'

import { DATE_FULL_FORMAT } from '../../../constants/date'
import { isClipboardWriteSupported } from '../../../utils/clipboard'
import { isValueFunctionType } from '../../../utils/common'
import { toUkTimezoneDate } from '../../../utils/date'
import { GRETA_CLIPBOARD_IGNORE_ATTRIBUTE } from '../GretaAIChat.constants'
import { formatGretaAIChatTimeRelative } from '../GretaAIChat.utils'

export { formatGretaAIChatTimeRelative }

export function isGretaAIChatRichClipboardSupported() {
  if (
    !isClipboardWriteSupported() ||
    !isValueFunctionType(window.ClipboardItem) ||
    !isValueFunctionType(navigator.clipboard.write)
  ) {
    return false
  }

  return (
    !isValueFunctionType(window.ClipboardItem.supports) ||
    (window.ClipboardItem.supports('text/html') &&
      window.ClipboardItem.supports('text/plain'))
  )
}

export function getGretaAIChatClipboardHtml(node) {
  const clone = node.cloneNode(true)
  const links = node.querySelectorAll('a[href]')
  const clonedLinks = clone.querySelectorAll('a[href]')

  clonedLinks.forEach((link, index) => {
    link.setAttribute('href', links[index].href)
  })

  clone
    .querySelectorAll(`[${GRETA_CLIPBOARD_IGNORE_ATTRIBUTE}]`)
    .forEach(element => element.remove())

  clone.querySelectorAll('del').forEach(element => {
    const strikethrough = document.createElement('s')

    strikethrough.append(...element.childNodes)
    element.replaceWith(strikethrough)
  })

  return clone.innerHTML
}

export function copyGretaAIChatReplyRich({ markdown, node }) {
  const item = new ClipboardItem({
    'text/html': new Blob([getGretaAIChatClipboardHtml(node)], {
      type: 'text/html',
    }),
    'text/plain': new Blob([markdown], { type: 'text/plain' }),
  })

  return navigator.clipboard.write([item]).then(
    () => true,
    () => false
  )
}

export function getGretaAIChatFeedbackTooltip({
  isActive,
  label,
  pendingValue,
  t,
}) {
  if (isActive) {
    return pendingValue
      ? t('Greta.FeedbackRemoveKey')
      : t('Greta.FeedbackSentTooltipKey')
  }

  return label
}

export function formatGretaAIChatTimeAbsolute(createdAt, locale, timeZone) {
  const date = timeZone
    ? toUkTimezoneDate(createdAt, timeZone)
    : new Date(createdAt)

  return format(date, DATE_FULL_FORMAT, { locale })
}
